/** 2D Monitor → 3D Cesium: map context is unmounted on route change; persist handoff here. */
const STORAGE_KEY = 'polaris.monitor.mapHandoff.v1';
export function zoomToRoughAltitudeMeters(zoom, latitudeDeg) {
    const z = Math.min(22, Math.max(2, zoom));
    const lat = (latitudeDeg * Math.PI) / 180;
    const worldWidthM = Math.cos(lat) * 2 * Math.PI * 6378137;
    const tileWidthM = worldWidthM / Math.pow(2, z);
    return Math.max(200, Math.min(2_500_000, tileWidthM * 2.2));
}
export function writeMonitorMapHandoff(handoff) {
    try {
        const payload = { ...handoff, savedAt: Date.now() };
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    }
    catch {
        // Ignore quota / privacy mode.
    }
}
export function readMonitorMapHandoff(maxAgeMs = 5 * 60_000) {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return undefined;
        }
        const parsed = JSON.parse(raw);
        if (typeof parsed.latitude !== 'number' ||
            typeof parsed.longitude !== 'number' ||
            Number.isNaN(parsed.latitude) ||
            Number.isNaN(parsed.longitude)) {
            sessionStorage.removeItem(STORAGE_KEY);
            return undefined;
        }
        if (parsed.savedAt != null && Date.now() - parsed.savedAt > maxAgeMs) {
            sessionStorage.removeItem(STORAGE_KEY);
            return undefined;
        }
        return parsed;
    }
    catch {
        return undefined;
    }
}
export function clearMonitorMapHandoff() {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    }
    catch {
        // ignore
    }
}
